import React, { useEffect, useRef } from 'react';
import { useClerk, useSignIn, useSignUp } from '@clerk/react';
import { useNavigate } from 'react-router-dom';

const SSOCallback = () => {
  const clerk = useClerk();
  const { signIn, isLoaded: signInLoaded } = useSignIn();
  const { signUp, isLoaded: signUpLoaded } = useSignUp();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (!clerk.loaded || !signInLoaded || !signUpLoaded || hasRun.current) return;

    (async () => {
      hasRun.current = true;

      try {
        // Case 1: Sign-in completed
        if (signIn.status === 'complete') {
          await clerk.setActive({ session: signIn.createdSessionId });
          navigate('/dashboard', { replace: true });
          return;
        }

        // Case 2: Sign-up transferable to sign-in (existing user via OAuth)
        if (signUp.isTransferable) {
          const result = await signIn.create({ transfer: true });
          if (result.status === 'complete') {
            await clerk.setActive({ session: result.createdSessionId });
            navigate('/dashboard', { replace: true });
            return;
          }
        }

        // Case 3: Sign-in transferable to sign-up (new user via OAuth)
        if (signIn.isTransferable) {
          const result = await signUp.create({ transfer: true });
          if (result.status === 'complete') {
            await clerk.setActive({ session: result.createdSessionId });
            navigate('/dashboard', { replace: true });
            return;
          }
        }

        // Case 4: Sign-up completed
        if (signUp.status === 'complete') {
          await clerk.setActive({ session: signUp.createdSessionId });
          navigate('/dashboard', { replace: true });
          return;
        }

        // Nothing matched - go back to login
        console.warn('SSO callback: no matching status', { signIn: signIn.status, signUp: signUp.status });
        navigate('/login', { replace: true });
      } catch (err) {
        console.error('SSO callback error:', err);
        navigate('/login', { replace: true });
      }
    })();
  }, [clerk.loaded, signInLoaded, signUpLoaded, signIn, signUp, navigate, clerk]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-2">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground"></div>
      <p className="text-sm text-muted-foreground">Signing in...</p>
    </div>
  );
};

export default SSOCallback;
